<div class="content">
    <div class="search-bar">
        <div class="input-group">
            <div class="left-icon">
                <i class="fa fa-search"></i>
            </div>
            <input (keyup.enter)="filterService.searchBySearchValue()"
                   [(ngModel)]="filterService.searchValue"
                   placeholder="Nach beliebigem Gerät suchen"/>
        </div>
        <button [disabled]="!filterService.canSearchBySearchValue()"
                (click)="filterService.searchBySearchValue()"
                class="search-button">
            <i class="fa fa-search"></i>
            Suchen
        </button>
    </div>
    <div (click)="filterDialog.open()" class="search-filter">
        <i class="fa fa-sliders"></i>
        Filter
    </div>
    <div (click)="navigateToBookmarks()" class="bookmarks">
        <i class="fa fa-star"></i>
        Merkliste
    </div>
    <div class="customer-mode" (click)="share.customerMode = !share.customerMode">
        <img
            [src]="share.customerMode ? consts.customerModeOnImageSource : consts.customerModeOffImageSource"/>
        Kundenmodus
    </div>
</div>

<bdcp-filter #filterDialog></bdcp-filter>
